import { useSelector } from "react-redux";
import { BottomPanel } from "../BottomPanel/BottomPanel";
import HotspotLocationEditor from "../HotspotLocationEditor/HotspotLocationEditor";
import { getCurrentStep } from "../../redux/selectors";
import { steps, versions } from "../../util/constants";
import { SMVPreviewModeSwitch } from "../SMVPreviewModeSwitch/SMVPreviewModeSwitch";
import SMVPreview from "../SMVPreview/SMVPreview";
import { getVersion } from "../../util/getVersion";

export function HotspotLocationEditorWithBottomPanel() {
  const version = getVersion();
  const step = useSelector(getCurrentStep);
  const inLocationMode = step === steps.configureLocations;
  return (
    <div
      style={{
        flex: "1 1 0",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minWidth: "0",
      }}
      className={inLocationMode ? "locationModeEditor" : ""}
    >
      {step === steps.SMVPreview ? (
        <SMVPreview />
      ) : (
        <HotspotLocationEditor
          style={{
            flex: "1 1 0",
          }}
        />
      )}
      <SMVPreviewModeSwitch />
      {version === versions.spin ? <BottomPanel /> : null}
    </div>
  );
}
